document.addEventListener("DOMContentLoaded", () => {

    document.querySelectorAll('.dropdown').forEach(elem => {
        elem.addEventListener('click', function (e) {
            this.classList.toggle('opened');
        });
    });

    if (document.querySelector('.speaker-btn')) {
        document.querySelector('.speaker-btn').addEventListener('click', function (event) {
            if (document.querySelector('.speaker-btn').classList.contains('opened')) {
                document.querySelector('.bio__text').classList.remove('opened')
                document.querySelector('.speaker-btn').classList.remove('opened')
                document.querySelector('.speaker-btn').innerText = 'Подробнее'
            } else {
                document.querySelector('.bio__text').classList.add('opened')
                document.querySelector('.speaker-btn').classList.add('opened')
                document.querySelector('.speaker-btn').innerText = 'Свернуть'
            }

        })
    }

    // если есть видео
    if(document.querySelector('.bl-video')) {
        const originalVideo = document.querySelector('.bl-video');
        const src = originalVideo.getAttribute('data-orig');
        if(!src) {
            return
        }
        const modal = document.getElementById('videoModal');
        const modalVideo = document.querySelector('.modal-video');
        modalVideo.setAttribute('src', src)
        const closeModal = document.getElementById('closeModal');

        // Функция для открытия модального окна
        function openModal() {
            modal.classList.add('active');
            modalVideo.currentTime = 0;
            modalVideo.play();
            document.body.style.overflow = 'hidden'; // Блокируем скролл страницы
        }

        // Функция для закрытия модального окна
        function closeModalHandler() {
            modal.classList.remove('active');
            modalVideo.pause();
            document.body.style.overflow = 'auto'; // Возвращаем скролл страницы
        }

        // События клика
        originalVideo.addEventListener('click', openModal);
        closeModal.addEventListener('click', closeModalHandler);

        // Закрытие по клику на оверлей (фон)
        modal.addEventListener('click', function (e) {
            if (e.target === modal) {
                closeModalHandler();
            }
        });

        // Закрытие по клавише Escape
        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape' && modal.classList.contains('active')) {
                closeModalHandler();
            }
        });

        // Пауза основного видео при открытии модального
        modalVideo.addEventListener('play', function () {
            originalVideo.pause();
        });

        // Возобновление основного видео при закрытии модального
        modalVideo.addEventListener('pause', function () {
            if (!modal.classList.contains('active')) {
                originalVideo.play();
            }
        });

    }



    if (document.querySelector('.swiper1')) {
            const swiper4 = new Swiper('.swiper1', {
                // Optional parameters
                slidesPerView: 1,
                spaceBetween: 12,
                // If we need pagination
                pagination: {
                    el: '.swiper-pagination',
                },

                // Navigation arrows
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },

            });
    }
    if (document.querySelector('.swiper2')) {
            const swiper5 = new Swiper('.swiper2', {
                // Optional parameters
                slidesPerView: 1,
                spaceBetween: 12,
                // If we need pagination
                pagination: {
                    el: '.swiper-pagination',
                },

                // Navigation arrows
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },

                breakpoints: {
                    // When window width is >= 768px
                    768: {
                        slidesPerView: 2,
                    },
                    1400: {
                        slidesPerView: 3,
                        slidesPerGroup: 3,
                        spaceBetween: 12,
                    },

                },

            });
    }


    // sitnikov premii videoframes

    if(document.querySelector('.premii')) {

        const videos = {
            'slide1': '/static/landings_v2/sitnikov/vid/ziz.mp4',
            'slide2': '/static/landings_v2/sitnikov/vid/koop.mp4',
            'slide3': '/static/landings_v2/sitnikov/vid/5.mp4',
            'slide4': '/static/landings_v2/sitnikov/vid/4.mp4',
            'slide5': '/static/landings_v2/sitnikov/vid/3.mp4',
        }



        document.querySelector('.premii').addEventListener('click', function(e) {
            if (e.target.closest('.card-vid')) {
                const vidId = e.target.getAttribute('id');
                for (const key in videos) {
                    if (vidId === key) {

                        var src = videos[key];

                        const iframe = document.createElement('div');
                        iframe.innerHTML = `
                        <video 
                            class="iframe-video" 
                                    width = '250'  height = '475' controls
                                    autoplay="autoplay">
                             <source src="${src}" type="video/mp4">
                        </video>
                        <button class="iframe-close">&times;</button>
                        <div class="overlay"></div>`;

                        iframe.classList.add('iframe-video-wrap');



                        document.querySelector('.app__content').appendChild(iframe)

                        document.querySelector('.overlay')
                            ? document.querySelector('.overlay').addEventListener('click', function () {
                                document.querySelector('.app__content').removeChild(document.querySelector('.iframe-video-wrap'))
                            }) : window.console.log(iframe);
                        document.querySelector('.iframe-close').addEventListener('click', function () {
                            document.querySelector('.app__content').removeChild(document.querySelector('.iframe-video-wrap'))
                        })
                    }
                }
            }



        });



    }

    // countdown Rodin

    if(document.querySelector('.timer')) {

        function getDaysWord(days) {
            const lastDigit = days % 10;
            const lastTwoDigits = days % 100;

            if (lastTwoDigits >= 11 && lastTwoDigits <= 14) {
                return 'дней';
            }

            if (lastDigit === 1) {
                return 'день';
            }

            if (lastDigit >= 2 && lastDigit <= 4) {
                return 'дня';
            }

            return 'дней';
        }

        function getHoursWord(hours) {
            const lastDigit = hours % 10;
            const lastTwoDigits = hours % 100;

            if (lastTwoDigits >= 11 && lastTwoDigits <= 14) {
                return 'часов';
            }

            if (lastDigit === 1) {
                return 'час';
            }

            if (lastDigit >= 2 && lastDigit <= 4) {
                return 'часа';
            }

            return 'часов';
        }

        function updateCountdown() {
            const timerElement = document.querySelector('.timer');
            const targetDateStr = timerElement.getAttribute('data-date');
            const targetDate = new Date(targetDateStr).getTime();
            const now = new Date().getTime();
            const timeLeft = targetDate - now;

            const countdownContainer = document.querySelector('.countdown-container');
            const courseStarted = document.getElementById('course-started');
            const timerLabel = document.querySelector('.timer-label');

            if (timeLeft <= 0) {
                // Показываем "Курс начался", скрываем таймер
                countdownContainer.classList.add('hide');
                timerLabel.classList.add('hide');
                courseStarted.classList.remove('hide');
                return;
            } else {
                // Показываем таймер, скрываем "Курс начался"
                countdownContainer.classList.remove('hide');
                timerLabel.classList.remove('hide');
                courseStarted.classList.add('hide');
            }


            const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
            const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));

            document.getElementById('days').textContent = days;
            document.getElementById('hours').textContent = hours.toString().padStart(2, '0');
            document.getElementById('days-label').textContent = getDaysWord(days);
            document.getElementById('hours-label').textContent = getHoursWord(hours);

            // Мигание двоеточия
            const colon = document.getElementById('colon');
            colon.classList.toggle('tic');
        }

        updateCountdown();
        setInterval(updateCountdown, 1000);
    }



/*
        const overlay = document.querySelector('.modal-overlay');

        if (overlay) {
            overlay.addEventListener('click', function(e) {
                // Проверяем, что клик именно по overlay, а не по вложенным элементам
                if (e.target === overlay) {
                    document.querySelector('.modal-ss').remove();
                    overlay.remove();
                }
            });
        }*/

    document.addEventListener('change', function(event) {
        // Проверяем, что клик произошел по нужному чекбоксу
        if (event.target.matches('.checkbox-company')) {
            const companyCheckbox = document.querySelector('.checkbox-company');
                    const companyInput = document.querySelector('.company-input');
                    if (companyInput) {
                        companyCheckbox.checked ? companyInput.style.display = 'block' : companyInput.style.display = 'none';
                    }
        }

    });


/*
        const formBuy = document.querySelector('.bl-info__btn');
        console.log('11')
        if(formBuy) {
            formBuy.addEventListener('click', (function() {
                setTimeout(function() {
                    const companyCheckbox = document.querySelector('.checkbox-company');
                    if (companyCheckbox) {
                        companyCheckbox.addEventListener('click', function() {
                            const companyInput = document.querySelector('.company-input');
                            if (companyInput) {
                                companyCheckbox.checked ? companyInput.style.display = 'block' : companyInput.style.display = 'none';
                            }


                        })
                    }
                }, 100)

            }))
        }
*/

})